// Patent Pending Icon - matches Magnus Core styling
import React from 'react';

const PatentPendingIcon: React.FC = () => {
    return (
        <div className="relative group">
            <div className="absolute -inset-0.5 bg-gradient-to-r from-yellow-400 to-yellow-600 rounded-lg blur opacity-75 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>
            <div className="relative px-3 py-1 bg-gray-900 rounded-lg leading-none flex items-center">
                <span className="text-yellow-400 font-semibold text-xs tracking-wider uppercase">Patent Pending</span>
            </div>
        </div>
    );
};

export default PatentPendingIcon;
